


import React, { useEffect, useState } from "react";
import "../styles/IntraAsia.css"; // Make sure to create this CSS file

const IntraAsia = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set visible to true after component mounts for animation
    setTimeout(() => {
      setVisible(true);
    }, 100);
  }, []);

  return (
    <div className="intra-asia-container">
      <div className={`coming-soon-wrapper ${visible ? 'visible' : ''}`}>
        <h1 className="coming-soon-text">Coming Soon</h1>
        <p className="coming-soon-subtext">We're working on bringing you the latest Intra-Asia schedules.</p>
      </div>
    </div>
  );
};

export default IntraAsia;